import {
  SET_DEFAULT_PLAN_IDS,
  SET_DEFAULT_DETAILS_LOADING,
  SET_DEFAULT_PRICES,
  SET_CUSTOM_PRICES,
  SET_CONNECT_DEVICES,
  SET_CONTROL_DEVICES,
  SET_LOADING_PAY,
  SET_SHOW_DIALOG,
  SET_SUBSCRIPTION_DETAILS,
  SHOW_NOTIFICATION,
  SET_ALL_PRICES,
  SET_SUBSCRIPTION_LOADING

} from './actions';

export const initialState = {
  planIds: {
    result: [],
  },
  priceDetails: {
    result: [],
  },

  customPriceDetails: {
    result: [],
  },
  allPriceDetails: {
    result: {},
  },
  connectDevices: 0,
  controlDevices: 0,
  showDialog: false,
  loadingPlans: false,
  loadingCustomPlans: false,
  loadingPlanIds: false,
  loadingPay: false,
  notification: { open: false, message: '', alertType: '' },
  subscriptionLoading: false
}

export const subscriptionState = {
  subscriptionDetails: {
    result: {},
  },
}


export const subscription = (state = subscriptionState, action: any) => {
  switch (action.type) {
    case SET_SUBSCRIPTION_DETAILS:
      let subscription: any = state.subscriptionDetails
      subscription.result = action.payload.data
      return { ...state, subscriptionDetails: subscription || {} };
    default:
      return state;
  }
}

export const plan = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_DEFAULT_PLAN_IDS:
      let planIds: any = state.planIds
      planIds.result = action.payload.result
      return { ...state, planIds: planIds || {}, loadingPlanIds: false };
    case SET_CUSTOM_PRICES:
      let customPriceDetails: any = state.customPriceDetails
      customPriceDetails.result = action.payload.result
      return { ...state, customPriceDetails: customPriceDetails || {}, loadingCustomPlans: false };
    case SET_DEFAULT_PRICES:
      let priceDetails: any = state.priceDetails
      priceDetails.result = action.payload.result
      return { ...state, priceDetails: priceDetails || {}, loadingPlans: false };
    case SET_DEFAULT_DETAILS_LOADING:
      return {
        ...state,
        loadingPlanIds: action.payload,
        loadingPlans: false
      };
    case SET_CONNECT_DEVICES:
      return {
        ...state,
        connectDevices: action.payload,
      };
    case SET_SHOW_DIALOG:
      return {
        ...state,
        showDialog: action.payload,
      };
    case SET_CONTROL_DEVICES:
      return {
        ...state,
        controlDevices: action.payload,
      };
    case SET_LOADING_PAY:
      return {
        ...state,
        loadingPay: action.payload,
      };
    case SHOW_NOTIFICATION:
      return {
        ...state,
        notification: action.payload,
      };
    case SET_ALL_PRICES:
      let allPriceDetails: any = state.allPriceDetails
      allPriceDetails.result = action.payload.result
      return { ...state, allPriceDetails: allPriceDetails || {}, loadingPlans: false };
    case SET_SUBSCRIPTION_LOADING:
      return {
        ...state,
        subscriptionLoading: action.payload,
      };
    default:
      return state;
  }
}